module.exports = __webpack_public_path__ + "img/refresh.023a7491.png";